import * as React from 'react'

import { AccessibleVideo, } from '../../../../../../Shared/index'
import { EVIDENCE_ON_LAPTOP, READING_FOR_EVIDENCE_ANIMATION_VIDEO } from '../asset_constants'

const ImmediateActionableFeedbackSlide = ({ slideGroupClassName, media=null, firstParagraph=null, }) => (
  <section className={`slide ${slideGroupClassName} immediate-actionable-feedback-slide`} key="immediate-actionable-feedback-slide">
    <div>
      <h1>Immediate, Actionable Feedback</h1>
      <div className="flex-wrapper">
        <div className="text">
          {firstParagraph}
          <p className="magic-paragraph">The magic of Reading for Evidence is all in this button:</p>
          <div className="quill-button contained green extra-large">Get Feedback</div>
          <p>When students click "Get feedback," Quill's teacher-built AI can show them where to reread, suggest information to add, or show an exemplar to follow.</p>
          <p>Here's what that looks like in action:</p>
        </div>
        {media || (
          <div className="tool-on-laptop">
            <img
              alt="Screenshot of a Quill Reading for Evidence activity full-screen on a laptop"
              loading="eager"
              src={EVIDENCE_ON_LAPTOP}
            />
            <div className='video-section'>
              <AccessibleVideo
                ariaLabel="Animation of a student typing a response to an Evidence prompt and receiving feedback on it"
                src={READING_FOR_EVIDENCE_ANIMATION_VIDEO}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  </section>
)

export default ImmediateActionableFeedbackSlide
